// Keeps the cost status draft form in step with the server copy it was loaded
// from, so a slow or failed save never silently swaps the PM's text for an
// older version.

const FINANCIAL_TABLE_KEY = 'financial_summary_table';

const narrativeEntries = (costStatusData) =>
	Object.entries(costStatusData || {})
		.filter(([key]) => key !== FINANCIAL_TABLE_KEY)
		.sort(([a], [b]) => a.localeCompare(b));

const plainText = (html) => {
	const doc = new DOMParser().parseFromString(String(html ?? ''), 'text/html');
	return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
};

// The server re-serializes the editor HTML on save, so compare the words, not
// the markup. A blank field and a missing one read the same to the PM.
const narrativeText = (costStatusData) =>
	JSON.stringify(
		narrativeEntries(costStatusData)
			.map(([key, html]) => [key, plainText(html)])
			.filter(([, text]) => text !== '')
	);

// Identifies one server copy of a project's cost status. The form reloads only
// when this changes; a remount against the same copy keeps unsaved edits.
export const draftSourceKey = (projectId, monthlyCostStatusData) =>
	JSON.stringify([
		projectId ?? null,
		monthlyCostStatusData?.month ?? null,
		monthlyCostStatusData?.last_updated_at ?? null,
		narrativeEntries(monthlyCostStatusData?.cost_status_data),
	]);

// A save whose response never arrived may still have been stored. Only claim it
// did when the server now holds exactly the text that was sent and that text
// differs from what the form was loaded with; anything else is unconfirmed.
export const saveLandedOnServer = ({ loaded, sent, sentStatus, server }) => {
	if (!server || server.cost_status !== sentStatus) return false;
	const sentText = narrativeText(sent);
	if (sentText === narrativeText(loaded?.cost_status_data)) return false;
	return narrativeText(server.cost_status_data) === sentText;
};
